import { Directive } from '@angular/core';
import { ShowOnEnterDirective } from './show-on-enter.directive';

@Directive({
  selector: '[showleft]',
  standalone: true,
})
export class ShowleftDirective extends ShowOnEnterDirective {
  protected override readonly direction = 'left';
}
